import { createApp } from 'vue/dist/vue.esm-bundler.js'

{
  const appConfig = {
    props: [
      'el'
    ],
    data(){
      return {
        loading: true,
        events: [],
        showingTomorrow: false
      }
    },
    mounted(){
      const urlParams = new URLSearchParams(window.location.search)
      const previewSchedule = urlParams.get('preview_schedule')

      const ajaxData = {
        action: 'fetch_simple_scehdule_events',
        terms: JSON.parse(this.el.getAttribute('data-terms')),
        attractions: JSON.parse(this.el.getAttribute('data-attractions')),
      }

      if (previewSchedule) {
        ajaxData.preview_schedule = previewSchedule
      }
      
      window.coolHelperFunctions.coolAjax(ajaxData, success => {
        this.loading = false
        this.events = success?.data?.events || []
        this.showingTomorrow = success?.data?.showing_tomorrow || false
      }, error => {
        this.loading = false
        console.log(error)
      })
    },
    computed: {
      showTodayContent(){
        return !this.showingTomorrow
      },
      showTomorrowContent(){
        return this.showingTomorrow
      },
      showNoneFoundContent(){
        return !this.loading && this.events.length === 0
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.simple-schedule-app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig, { el })
        app.mount(el)
      })
    }
  }

  initApp()  
}